import { isEmpty, noop } from 'lodash'

import api from 'common/api'

const fetchContent = (scid) => api.get(`/api/colleges/${scid}/content`)

export const fetchCollege = (scid, fields = [], affiliateFields = '') => {
  const f = isEmpty(fields) ? '' : `?fields=${fields.join(',')}`
  const a = isEmpty(affiliateFields) ? '' : `&affiliateFields=${affiliateFields}`
  return api.get(`/api/college/${scid}${f + a}`)
}

export const loadCollegeWithContent = (scid, fields, affiliateFields) => {
  return Promise.all([fetchCollege(scid, fields, affiliateFields).catch(noop), fetchContent(scid)]).then((values) => {
    return {
      college: values[0],
      content: values[1],
    }
  })
}

export default loadCollegeWithContent
